import React from 'react';

const TrackingHistoryTableLoadable = React.lazy(() => import('./TrackingHistoryTable'))

export {
    TrackingHistoryTableLoadable
}